webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(44);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(126);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vuex = __webpack_require__(19);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _App = __webpack_require__(107);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _routes = __webpack_require__(58);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _smoothscrollPolyfill = __webpack_require__(106);
	
	var _smoothscrollPolyfill2 = _interopRequireDefault(_smoothscrollPolyfill);
	
	var _store = __webpack_require__(59);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _es6Promise = __webpack_require__(101);
	
	var _es6Promise2 = _interopRequireDefault(_es6Promise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_smoothscrollPolyfill2.default.polyfill();
	_es6Promise2.default.polyfill();
	
	var router = new _vueRouter2.default({
		routes: _routes2.default
	});
	
	_vue2.default.use(_vueRouter2.default);
	
	new _vue2.default({
		el: '#app',
		template: '<App/>',
		components: { App: _App2.default },
		router: router,
		store: _store2.default
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var PHOTO_SIZES = {
		SQUARE: 0,
		LARGE_SQUARE: 1,
		THUMBNAIL: 2,
		SMALL: 3,
		SMALL_320: 4,
		MEDIUM: 5,
		MEDIUM_640: 6,
		LARGE: 7
	};
	exports.default = PHOTO_SIZES;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _PhotoSizes = __webpack_require__(11);
	
	var _PhotoSizes2 = _interopRequireDefault(_PhotoSizes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoMixin = {
		props: {
			id: {
				type: String
			},
			includeMeta: {
				type: Boolean,
				default: false
			},
			size: {
				type: Number,
				default: _PhotoSizes2.default.MEDIUM
			}
		},
		computed: {
			photoId: function photoId() {
				return this.id;
			}
		},
		created: function created() {
			if (this.photoId) {
				this.requestSizes(this.photoId);
				this.requestInfo(this.photoId);
			}
		},
		data: function data() {
			return {
				hasSizesData: false,
				imageLoaded: false,
				meta: {
					title: "--",
					description: "--"
				},
				sizes: undefined,
				source: undefined
			};
		},
	
		methods: {
			requestSizes: function requestSizes(photoId) {
				var component = this;
				Flickr.requestPhotoSizes(photoId, function (x, sizes) {
					if (sizes) {
						component.sizes = sizes;
						component.hasSizesData = true;
					}
				});
			},
			requestInfo: function requestInfo(photoId) {
				var component = this;
				Flickr.requestPhotoInfo(photoId, function (x, info) {
					if (info) {
						component.meta = info;
						component.meta.title = component.meta.title || { _content: "--" };
					}
				});
			},
			fadeBackgroundOnLoad: function fadeBackgroundOnLoad(imagePath) {
				var image = new Image();
				var component = this;
				image.onload = function () {
					component.imageLoaded = true;
				};
				image.src = imagePath;
			},
			getImageSource: function getImageSource(size) {
				return this.sizes[size].source;
			}
		}
	};
	
	exports.default = PhotoMixin;

/***/ },
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var IntroScrollingMixin = {
		methods: {
			scrollToMain: function scrollToMain() {
				var $intro = document.getElementById("site-intro");
				if ($intro) {
					var introHeight = $intro.clientHeight;
					window.scrollTo({ left: 0, top: introHeight, behavior: 'smooth' });
				}
			},
			scrollToIntro: function scrollToIntro() {
				if (this.$route.name == "home") {
					window.scroll({ left: 0, top: 0, behavior: 'smooth' });
				}
			},
			scrollToTop: function scrollToTop() {
				window.scroll({ left: 0, top: 0, behavior: 'smooth' });
			}
		}
	};
	
	exports.default = IntroScrollingMixin;

/***/ },
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(47)
	
	/* template */
	var __vue_template__ = __webpack_require__(122)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 44 */,
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _SiteFooter = __webpack_require__(111);
	
	var _SiteFooter2 = _interopRequireDefault(_SiteFooter);
	
	var _Navbar = __webpack_require__(108);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _SiteIntro = __webpack_require__(112);
	
	var _SiteIntro2 = _interopRequireDefault(_SiteIntro);
	
	var _IntroScrolling = __webpack_require__(33);
	
	var _IntroScrolling2 = _interopRequireDefault(_IntroScrolling);
	
	var _vuex = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'app',
		components: {
			Navbar: _Navbar2.default,
			SiteFooter: _SiteFooter2.default,
			SiteIntro: _SiteIntro2.default
		},
		computed: (0, _vuex.mapGetters)(['introOpen', 'modalOpen']),
		created: function created() {
			if (this.$route.name != "home") {
				this.$store.commit('toggleIntro', false);
			}
		},
	
		mixins: [_IntroScrolling2.default],
		watch: {
			'$route': function $route() {
				var showIntro = !!this.$route.params.intro;
				if (this.$route.name == "home") {
					this.$store.commit('toggleIntro', showIntro);
					if (showIntro) {
						setTimeout(this.scrollToTop, 100);
					} else {
						setTimeout(this.scrollToMain, 100);
					}
				} else {
					setTimeout(this.scrollToTop, 100);
					this.$store.commit('toggleIntro', false);
				}
			}
		}
	};

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _IntroScrolling = __webpack_require__(33);
	
	var _IntroScrolling2 = _interopRequireDefault(_IntroScrolling);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PHOTOGRAPY_ROUTES = ["photoset", "photo"];
	exports.default = {
		mixins: [_IntroScrolling2.default],
		computed: {
			isPhotographyRoute: function isPhotographyRoute() {
				return PHOTOGRAPY_ROUTES.includes(this.$route.name);
			}
		}
	};

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _flickr = __webpack_require__(55);
	
	var _flickr2 = _interopRequireDefault(_flickr);
	
	var _Photo = __webpack_require__(12);
	
	var _Photo2 = _interopRequireDefault(_Photo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		methods: {
			getSource: function getSource() {
				return this.sizes[this.size].source;
			},
			handleImageLoad: function handleImageLoad() {
				this.imageLoaded = true;
			}
		},
		mixins: [_Photo2.default],
		props: {
			id: {
				type: String
			}
		}
	};

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Photo = __webpack_require__(12);
	
	var _Photo2 = _interopRequireDefault(_Photo);
	
	var _PhotoSizes = __webpack_require__(11);
	
	var _PhotoSizes2 = _interopRequireDefault(_PhotoSizes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ANIMATION_DELAY = 100;
	
	exports.default = {
		computed: {
			photoId: function photoId() {
				return this.id;
			},
			photoSource: function photoSource() {
				return this.sizes ? this.sizes[_PhotoSizes2.default.LARGE].source : undefined;
			}
		},
		created: function created() {
			var component = this;
			setTimeout(function () {
				component.isIn = true;
			}, ANIMATION_DELAY);
			window.addEventListener('keydown', this._keyDownHandler);
			window.addEventListener('keyup', this._keyUpHandler);
		},
		destroyed: function destroyed() {
			window.removeEventListener('keydown', this._keyDownHandler);
			window.removeEventListener('keyup', this._keyUpHandler);
		},
		data: function data() {
			return {
				isIn: false,
				keyPressed: false
			};
		},
	
		methods: {
			handleClose: function handleClose() {
				var component = this;
				this.isIn = false;
				setTimeout(function () {
					component.$router.push({
						name: 'photoset',
						params: { id: component.$route.params.id }
					});
				}, ANIMATION_DELAY);
			},
			handleImageLoad: function handleImageLoad() {
				this.imageLoaded = true;
			},
			handleKeyPress: function handleKeyPress(e) {
				var currentPhoto = Number(this.$route.query.photo);
				if (e.keyCode == 27) {
					this.handleClose();
				} else if (e.keyCode == 37) {
					if (this.previous != null) {
						this.goToIndex(currentPhoto - 1);
					}
				} else if (e.keyCode == 39) {
					if (this.next != null) {
						this.goToIndex(currentPhoto + 1);
					}
				}
			},
			_keyDownHandler: function _keyDownHandler(e) {
				if (!this.keyPressed) {
					this.keyPressed = true;
					this.handleKeyPress(e);
				}
			},
			_keyUpHandler: function _keyUpHandler(e) {
				this.keyPressed = false;
			},
			goToIndex: function goToIndex(index) {
				this.$router.push({
					name: 'photoset',
					params: { id: this.$route.params.id },
					query: { photo: index }
				});
			}
		},
		mixins: [_Photo2.default],
		props: {
			id: {
				type: String
			},
			next: {
				default: null,
				type: Number
			},
			previous: {
				default: null,
				type: Number
			}
		}
	};

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Photo = __webpack_require__(43);
	
	var _Photo2 = _interopRequireDefault(_Photo);
	
	var _PhotoSizes = __webpack_require__(11);
	
	var _PhotoSizes2 = _interopRequireDefault(_PhotoSizes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		computed: {
			photoId: function photoId() {
				return this.details.primary;
			},
			photoSource: function photoSource() {
				return this.sizes ? this.sizes[_PhotoSizes2.default.LARGE].source : undefined;
			}
		},
		props: ['details'],
		mixins: [_Photo2.default],
		watch: {
			hasSizesData: function hasSizesData() {
				this.fadeBackgroundOnLoad(this.photoSource);
			}
		}
	};

/***/ },
/* 50 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		computed: {
			year: function year() {
				return new Date().getFullYear();
			}
		}
	};

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _extends2 = __webpack_require__(65);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Photo = __webpack_require__(12);
	
	var _Photo2 = _interopRequireDefault(_Photo);
	
	var _PhotoSizes = __webpack_require__(11);
	
	var _PhotoSizes2 = _interopRequireDefault(_PhotoSizes);
	
	var _vuex = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FEATURE_IMAGES = ["514080236", "4402846583", "514080242", "1802622748", "1801772595", "4308243203", "3053276533"];
	
	exports.default = {
		computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['introOpen']), {
			photoSource: function photoSource() {
				return this.sizes ? this.sizes[_PhotoSizes2.default.LARGE].source : undefined;
			},
			photoId: function photoId() {
				return this.getFeaturedImageId();
			}
		}),
		created: function created() {
			var component = this;
			window.addEventListener('scroll', function () {
				component.handleScroll.apply(this, arguments);
			});
			this.setIntroScrollPosition();
		},
		data: function data() {
			return {
				introFade: 0
			};
		},
	
		methods: {
			handleScroll: function handleScroll(e) {
				this.setIntroScrollPosition();
			},
			getFeaturedImageId: function getFeaturedImageId() {
				return FEATURE_IMAGES[new Date().getDay()];
			},
			setIntroScrollPosition: function setIntroScrollPosition() {
				var scrollPos = window.scrollY;
				var $intro = this.$refs.intro;
				if ($intro) {
					var introHeight = $intro.clientHeight;
					this.introFade = Math.min(scrollPos / introHeight * 100, 100);
				}
			}
		},
		mixins: [_Photo2.default],
		watch: {
			hasSizesData: function hasSizesData(newVal) {
				if (newVal) {
					this.fadeBackgroundOnLoad(this.photoSource);
				}
			},
			introFade: function introFade() {
				this.$store.commit("toggleIntro", this.introFade < 100);
			}
		}
	};

/***/ },
/* 52 */
/***/ function(module, exports) {

	"use strict";

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _PhotosetIntro = __webpack_require__(110);
	
	var _PhotosetIntro2 = _interopRequireDefault(_PhotosetIntro);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			PhotosetIntro: _PhotosetIntro2.default
		},
		created: function created() {
			this._requestPhotosets();
		},
		data: function data() {
			return {
				hasPhotosets: false,
				photosets: null
			};
		},
	
		methods: {
			_requestPhotosets: function _requestPhotosets() {
				var component = this;
				Flickr.requestPhotosetList(function (x, list) {
					component.photosets = list;
					component.hasPhotosets = true;
				});
			},
			goToPhotoset: function goToPhotoset(photosetId) {
				this.$router.push({
					name: 'photoset',
					params: {
						id: photosetId
					}
				});
			}
		}
	};

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _Photo = __webpack_require__(43);
	
	var _Photo2 = _interopRequireDefault(_Photo);
	
	var _PhotoFullScreen = __webpack_require__(109);
	
	var _PhotoFullScreen2 = _interopRequireDefault(_PhotoFullScreen);
	
	var _Photo3 = __webpack_require__(12);
	
	var _Photo4 = _interopRequireDefault(_Photo3);
	
	var _PhotoSizes = __webpack_require__(11);
	
	var _PhotoSizes2 = _interopRequireDefault(_PhotoSizes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			Photo: _Photo2.default,
			PhotoFullScreen: _PhotoFullScreen2.default
		},
		computed: {
			photoSource: function photoSource() {
				return this.sizes ? this.sizes[_PhotoSizes2.default.LARGE].source : undefined;
			},
			activePhoto: function activePhoto() {
				var val = undefined;
				if (this.activePhotoIndex !== undefined && this.photos && this.photos[this.activePhotoIndex]) {
					val = this.photos[this.activePhotoIndex].id || undefined;
				}
				return val;
			},
			activePhotoIndex: function activePhotoIndex() {
				var val = undefined;
				if (this.$route.query && this.$route.query.photo !== undefined) {
					val = Number(this.$route.query.photo);
				}
				return val;
			}
		},
		created: function created() {
			this._requestPhotosetInfo();
			this._requestPhotosetPhotos();
		},
		data: function data() {
			return {
				hasPhotosetData: false,
				hasPhotos: false,
				photosetData: null,
				photos: null
			};
		},
	
		methods: {
			_requestPhotosetInfo: function _requestPhotosetInfo() {
				var component = this;
				Flickr.requestPhotosetInfo(this.$route.params.id, function (x, photoset) {
					if (photoset) {
						component.photosetData = photoset;
						component.hasPhotosetData = true;
					}
				});
			},
			_requestPhotosetPhotos: function _requestPhotosetPhotos() {
				var component = this;
				Flickr.requestPhotosetPhotos(this.$route.params.id, function (x, photos) {
					if (photos) {
						component.photos = photos;
						component.hasPhotos = true;
					}
				});
			},
			handlePhotoClick: function handlePhotoClick(photoIndex) {
				this.$router.push({
					name: 'photoset',
					params: { id: this.$route.params.id },
					query: { photo: photoIndex }
				});
			}
		},
		mixins: [_Photo4.default],
		watch: {
			hasPhotosetData: function hasPhotosetData() {
				if (this.photosetData.primary) {
					this.requestSizes(this.photosetData.primary);
				}
			},
			hasSizesData: function hasSizesData() {
				this.fadeBackgroundOnLoad(this.photoSource);
			},
			activePhoto: function activePhoto() {
				this.$store.commit("toggleModalOpen", !!this.activePhoto);
			}
		}
	};

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _flickrapi = __webpack_require__(56);
	
	var _flickrapi2 = _interopRequireDefault(_flickrapi);
	
	var _env = __webpack_require__(57);
	
	var _env2 = _interopRequireDefault(_env);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Flickr = window.Flickr = new _flickrapi2.default.Flickr({
		'api_key': _env2.default.FLICKR_API_KEY,
		'secret': _env2.default.FLICKR_SECRET,
		'user_id': _env2.default.FLICKR_USER_ID
	});
	
	Flickr._cache = {
		sizes: {},
		photosetInfo: {},
		photosetPhotos: {},
		photosetList: null,
		photoInfo: {}
	};
	
	Flickr.requestPhotoSizes = function (photoId, handler) {
		var flickr = this;
		if (this._cache.sizes[photoId]) {
			handler({ fromCache: true }, this._cache.sizes[photoId]);
		} else {
			Flickr.photos.getSizes({
				'photo_id': photoId
			}, function (x, response) {
				if (response && response.sizes && response.sizes.size) {
					flickr._cache.sizes[photoId] = response.sizes.size;
					handler(x, response.sizes.size);
				} else {
					console.error("requestPhotoSizes error");
				}
			});
		}
	};
	
	Flickr.requestPhotosetPhotos = function (photosetId, handler) {
		var flickr = this;
		if (this._cache.photosetPhotos[photosetId]) {
			handler({ fromCache: true }, this._cache.photosetPhotos[photosetId]);
		} else {
			Flickr.photosets.getPhotos({
				'photoset_id': photosetId
			}, function (x, response) {
				if (response && response.photoset && response.photoset.photo) {
					flickr._cache.photosetPhotos[photosetId] = response.photoset.photo;
					handler(x, response.photoset.photo);
				} else {
					console.error("requestPhotosetPhotos error");
				}
			});
		}
	};
	
	Flickr.requestPhotosetInfo = function (photosetId, handler) {
		var flickr = this;
		if (this._cache.photosetInfo[photosetId]) {
			handler({ fromCache: true }, this._cache.photosetInfo[photosetId]);
		} else {
			Flickr.photosets.getInfo({
				'photoset_id': photosetId
			}, function (x, response) {
				if (response && response.photoset && response.photoset.id) {
					flickr._cache.photosetInfo[photosetId] = response.photoset;
					handler(x, response.photoset);
				} else {
					console.error("requestPhotosetInfo error");
				}
			});
		}
	};
	
	Flickr.requestPhotoInfo = function (photoId, handler) {
		var flickr = this;
		if (this._cache.photoInfo[photoId]) {
			handler({ fromCache: true }, this._cache.photoInfo[photoId]);
		} else {
			Flickr.photos.getInfo({
				'photo_id': photoId
			}, function (x, response) {
				if (response && response.photo) {
					flickr._cache.photoInfo[photoId] = response.photo;
					handler(x, response.photo);
				} else {
					console.error("requestPhotoInfo error");
				}
			});
		}
	};
	
	Flickr.requestPhotosetList = function (handler) {
		var flickr = this;
		if (this._cache.photosetList != null) {
			handler({ fromCache: true }, this._cache.photosetList);
		} else {
			Flickr.photosets.getList({
				'user_id': _env2.default.FLICKR_USER_ID
			}, function (x, response) {
				if (response && response.photosets && response.photosets.photoset) {
					flickr._cache.photosetList = response.photosets.photoset;
					handler(x, response.photosets.photoset);
				} else {
					console.error("requestPhotosetList error");
				}
			});
		}
	};
	
	exports.default = Flickr;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof2 = __webpack_require__(66);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _stringify = __webpack_require__(60);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(62);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(function () {
		var Utils = {};
		Utils.encodeRFC5987ValueChars = function (str) {
			return encodeURIComponent(str).replace(/['()!]/g, escape).replace(/\*/g, '%2A').replace(/%(?:7C|60|5E)/g, unescape);
		};
		Utils.formQueryString = function (queryArguments) {
			var Utils = this,
			    args = [],
			    append = function append(key) {
				args.push(key + "=" + Utils.encodeRFC5987ValueChars(queryArguments[key]));
			};
			(0, _keys2.default)(queryArguments).sort().forEach(append);
			return args.join("&");
		};
		Utils.checkRequirements = function (method_name, required, callOptions, callback) {
			required = required || [];
			for (var r = 0, last = required.length, arg; r < last; r++) {
				arg = required[r];
				if (arg.name === "api_key") continue;
				if (!callOptions.hasOwnProperty(arg.name)) {
					return callback(new Error("missing required argument '" + arg.name + "' in call to " + method_name));
				}
			}
		};
		Utils.generateAPIFunction = function (method) {
			return function (callOptions, callback) {
				if (callOptions && !callback) {
					callback = callOptions;
					callOptions = {};
				}
				var queryArguments = Utils.generateQueryArguments(method.name, this.flickrOptions, callOptions);
				Utils.queryFlickr(queryArguments, this.flickrOptions, method.security, callback);
			};
		};
		Utils.generateAPIDevFunction = function (method) {
			return function (callOptions, callback) {
				if (callOptions && !callback) {
					callback = callOptions;
					callOptions = {};
				}
				Utils.checkRequirements(method.name, method.required, callOptions, callback);
				var queryArguments = Utils.generateQueryArguments(method.name, this.flickrOptions, callOptions);
				Utils.queryFlickr(queryArguments, this.flickrOptions, method.security, callback, method.errors);
			};
		};
		Utils.generateQueryArguments = function (method_name, flickrOptions, callOptions) {
			var queryArguments = {
				method: method_name,
				format: "json"
			};
			if (flickrOptions.api_key) {
				queryArguments.api_key = flickrOptions.api_key;
			}
	
			(0, _keys2.default)(callOptions).forEach(function (key) {
				queryArguments[key] = callOptions[key];
			});
			return queryArguments;
		};
		Utils.queryFlickr = function (queryArguments, flickrOptions, security, processResult) {
			if (flickrOptions.endpoint) {
				return this.queryProxyEndpoint(queryArguments, flickrOptions, processResult);
			}
			return this.queryFlickrAPI(queryArguments, flickrOptions, security, processResult);
		};
		Utils.upload = function (uploadOptions, flickrOptions, processResult) {
			return processResult(new Error("Uploading directly from the browser is not supported"));
		};
		Utils.queryFlickrAPI = function (queryArguments, flickrOptions, security, processResult) {
			var url = "https://api.flickr.com/services/rest/",
			    queryString = this.formQueryString(queryArguments),
			    flickrURL = url + "?" + queryString;
	
			if (security.requiredperms > 0) {
				return processResult(new Error("signed calls (write/delete) currently not supported"));
			}
			this.handleURLRequest("GET", flickrURL, processResult);
		};
		Utils.queryProxyEndpoint = function (queryArguments, flickrOptions, processResult) {
			var queryString = this.formQueryString(queryArguments),
			    url = flickrOptions.endpoint + "?" + queryString;
			this.handleURLRequest("POST", url, processResult, queryArguments);
		};
		Utils.handleURLRequest = function (verb, url, processResult, postdata) {
			var xhr = new XMLHttpRequest();
			xhr.open(verb, url, true);
			if (postdata) {
				xhr.setRequestHeader("Content-Type", "application/json");
			}
			xhr.onreadystatechange = function () {
				if (xhr.readyState === 4) {
					if (xhr.status == 200) {
						var error = false,
						    body = xhr.responseText;
	
						if (!body) {
							error = "HTTP Error " + response.statusCode + " (" + statusCodes[response.statusCode] + ")";
							return processResult(error);
						}
	
						if (!error) {
							try {
								body = body.trim().replace(/^jsonFlickrApi\(/, '').replace(/\}\)$/, '}');
								body = JSON.parse(body);
								if (body.stat !== "ok") {
									return processResult(body.message);
								}
							} catch (e) {
								return processResult("could not parse body as JSON");
							}
						}
	
						processResult(error, body);
					} else {
						processResult("HTTP status not 200 (received " + xhr.status + ")");
					}
				}
			};
			xhr.send(postdata ? (0, _stringify2.default)(postdata) : null);
		};
		Utils.errors = {
			"95": {
				"code": 95,
				"message": "SSL is required",
				"_content": "SSL is required to access the Flickr API."
			},
			"96": {
				"code": 96,
				"message": "Invalid signature",
				"_content": "The passed signature was invalid."
			},
			"97": {
				"code": 97,
				"message": "Missing signature",
				"_content": "The call required signing but no signature was sent."
			},
			"98": {
				"code": 98,
				"message": "Login failed / Invalid auth token",
				"_content": "The login details or auth token passed were invalid."
			},
			"99": {
				"code": 99,
				"message": "User not logged in / Insufficient permissions",
				"_content": "The method requires user authentication but the user was not logged in, or the authenticated method call did not have the required permissions."
			},
			"100": {
				"code": 100,
				"message": "Invalid API Key",
				"_content": "The API key passed was not valid or has expired."
			},
			"105": {
				"code": 105,
				"message": "Service currently unavailable",
				"_content": "The requested service is temporarily unavailable."
			},
			"106": {
				"code": 106,
				"message": "Write operation failed",
				"_content": "The requested operation failed due to a temporary issue."
			},
			"108": {
				"code": "108",
				"message": "Invalid frob",
				"_content": "The specified frob does not exist or has already been used."
			},
			"111": {
				"code": 111,
				"message": "Format \"xxx\" not found",
				"_content": "The requested response format was not found."
			},
			"112": {
				"code": 112,
				"message": "Method \"xxx\" not found",
				"_content": "The requested method was not found."
			},
			"114": {
				"code": 114,
				"message": "Invalid SOAP envelope",
				"_content": "The SOAP envelope send in the request could not be parsed."
			},
			"115": {
				"code": 115,
				"message": "Invalid XML-RPC Method Call",
				"_content": "The XML-RPC request document could not be parsed."
			},
			"116": {
				"code": 116,
				"message": "Bad URL found",
				"_content": "One or more arguments contained a URL that has been used for abuse on Flickr."
			}
		};
		var Flickr = function Flickr(flickrOptions) {
			this.bindOptions(flickrOptions);
		};
		Flickr.prototype = {};
		Flickr.methods = {
			"flickr.activity.userComments": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.activity.userComments"
			},
			"flickr.activity.userPhotos": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.activity.userPhotos"
			},
			"flickr.auth.checkToken": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.auth.checkToken"
			},
			"flickr.auth.getFrob": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.auth.getFrob"
			},
			"flickr.auth.getFullToken": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.auth.getFullToken"
			},
			"flickr.auth.getToken": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.auth.getToken"
			},
			"flickr.auth.oauth.checkToken": {
				"security": {
					"needslogin": 0,
					"needssigning": 1,
					"requiredperms": 0
				},
				"name": "flickr.auth.oauth.checkToken"
			},
			"flickr.auth.oauth.getAccessToken": {
				"security": {
					"needslogin": 0,
					"needssigning": 1,
					"requiredperms": 0
				},
				"name": "flickr.auth.oauth.getAccessToken"
			},
			"flickr.blogs.getList": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.blogs.getList"
			},
			"flickr.blogs.getServices": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.blogs.getServices"
			},
			"flickr.blogs.postPhoto": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.blogs.postPhoto"
			},
			"flickr.cameras.getBrandModels": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.cameras.getBrandModels"
			},
			"flickr.cameras.getBrands": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.cameras.getBrands"
			},
			"flickr.collections.getInfo": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.collections.getInfo"
			},
			"flickr.collections.getTree": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.collections.getTree"
			},
			"flickr.commons.getInstitutions": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.commons.getInstitutions"
			},
			"flickr.contacts.getList": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.contacts.getList"
			},
			"flickr.contacts.getListRecentlyUploaded": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.contacts.getListRecentlyUploaded"
			},
			"flickr.contacts.getPublicList": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.contacts.getPublicList"
			},
			"flickr.contacts.getTaggingSuggestions": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.contacts.getTaggingSuggestions"
			},
			"flickr.favorites.add": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.favorites.add"
			},
			"flickr.favorites.getContext": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.favorites.getContext"
			},
			"flickr.favorites.getList": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.favorites.getList"
			},
			"flickr.favorites.getPublicList": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.favorites.getPublicList"
			},
			"flickr.favorites.remove": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.favorites.remove"
			},
			"flickr.galleries.addPhoto": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.galleries.addPhoto"
			},
			"flickr.galleries.create": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.galleries.create"
			},
			"flickr.galleries.editMeta": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.galleries.editMeta"
			},
			"flickr.galleries.editPhoto": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.galleries.editPhoto"
			},
			"flickr.galleries.editPhotos": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.galleries.editPhotos"
			},
			"flickr.galleries.getInfo": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.galleries.getInfo"
			},
			"flickr.galleries.getList": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.galleries.getList"
			},
			"flickr.galleries.getListForPhoto": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.galleries.getListForPhoto"
			},
			"flickr.galleries.getPhotos": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.galleries.getPhotos"
			},
			"flickr.groups.browse": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.groups.browse"
			},
			"flickr.groups.discuss.replies.add": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.groups.discuss.replies.add"
			},
			"flickr.groups.discuss.replies.delete": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 3
				},
				"name": "flickr.groups.discuss.replies.delete"
			},
			"flickr.groups.discuss.replies.edit": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.groups.discuss.replies.edit"
			},
			"flickr.groups.discuss.replies.getInfo": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.groups.discuss.replies.getInfo"
			},
			"flickr.groups.discuss.replies.getList": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.groups.discuss.replies.getList"
			},
			"flickr.groups.discuss.topics.add": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.groups.discuss.topics.add"
			},
			"flickr.groups.discuss.topics.getInfo": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.groups.discuss.topics.getInfo"
			},
			"flickr.groups.discuss.topics.getList": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.groups.discuss.topics.getList"
			},
			"flickr.groups.getInfo": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.groups.getInfo"
			},
			"flickr.groups.join": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.groups.join"
			},
			"flickr.groups.joinRequest": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.groups.joinRequest"
			},
			"flickr.groups.leave": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 3
				},
				"name": "flickr.groups.leave"
			},
			"flickr.groups.members.getList": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.groups.members.getList"
			},
			"flickr.groups.pools.add": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.groups.pools.add"
			},
			"flickr.groups.pools.getContext": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.groups.pools.getContext"
			},
			"flickr.groups.pools.getGroups": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.groups.pools.getGroups"
			},
			"flickr.groups.pools.getPhotos": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.groups.pools.getPhotos"
			},
			"flickr.groups.pools.remove": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.groups.pools.remove"
			},
			"flickr.groups.search": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.groups.search"
			},
			"flickr.interestingness.getList": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.interestingness.getList"
			},
			"flickr.machinetags.getNamespaces": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.machinetags.getNamespaces"
			},
			"flickr.machinetags.getPairs": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.machinetags.getPairs"
			},
			"flickr.machinetags.getPredicates": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.machinetags.getPredicates"
			},
			"flickr.machinetags.getRecentValues": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.machinetags.getRecentValues"
			},
			"flickr.machinetags.getValues": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.machinetags.getValues"
			},
			"flickr.panda.getList": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.panda.getList"
			},
			"flickr.panda.getPhotos": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.panda.getPhotos"
			},
			"flickr.people.findByEmail": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.people.findByEmail"
			},
			"flickr.people.findByUsername": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.people.findByUsername"
			},
			"flickr.people.getGroups": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.people.getGroups"
			},
			"flickr.people.getInfo": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.people.getInfo"
			},
			"flickr.people.getLimits": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.people.getLimits"
			},
			"flickr.people.getPhotos": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.people.getPhotos"
			},
			"flickr.people.getPhotosOf": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.people.getPhotosOf"
			},
			"flickr.people.getPublicGroups": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.people.getPublicGroups"
			},
			"flickr.people.getPublicPhotos": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.people.getPublicPhotos"
			},
			"flickr.people.getUploadStatus": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.people.getUploadStatus"
			},
			"flickr.photos.addTags": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.addTags"
			},
			"flickr.photos.comments.addComment": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.comments.addComment"
			},
			"flickr.photos.comments.deleteComment": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.comments.deleteComment"
			},
			"flickr.photos.comments.editComment": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.comments.editComment"
			},
			"flickr.photos.comments.getList": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.photos.comments.getList"
			},
			"flickr.photos.comments.getRecentForContacts": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.photos.comments.getRecentForContacts"
			},
			"flickr.photos.delete": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 3
				},
				"name": "flickr.photos.delete"
			},
			"flickr.photos.geo.batchCorrectLocation": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.geo.batchCorrectLocation"
			},
			"flickr.photos.geo.correctLocation": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.geo.correctLocation"
			},
			"flickr.photos.geo.getLocation": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.photos.geo.getLocation"
			},
			"flickr.photos.geo.getPerms": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.photos.geo.getPerms"
			},
			"flickr.photos.geo.photosForLocation": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.photos.geo.photosForLocation"
			},
			"flickr.photos.geo.removeLocation": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.geo.removeLocation"
			},
			"flickr.photos.geo.setContext": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.geo.setContext"
			},
			"flickr.photos.geo.setLocation": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.geo.setLocation"
			},
			"flickr.photos.geo.setPerms": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.geo.setPerms"
			},
			"flickr.photos.getAllContexts": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.photos.getAllContexts"
			},
			"flickr.photos.getContactsPhotos": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.photos.getContactsPhotos"
			},
			"flickr.photos.getContactsPublicPhotos": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.photos.getContactsPublicPhotos"
			},
			"flickr.photos.getContext": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.photos.getContext"
			},
			"flickr.photos.getCounts": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.photos.getCounts"
			},
			"flickr.photos.getExif": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.photos.getExif"
			},
			"flickr.photos.getFavorites": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.photos.getFavorites"
			},
			"flickr.photos.getInfo": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.photos.getInfo"
			},
			"flickr.photos.getNotInSet": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.photos.getNotInSet"
			},
			"flickr.photos.getPerms": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.photos.getPerms"
			},
			"flickr.photos.getRecent": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.photos.getRecent"
			},
			"flickr.photos.getSizes": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.photos.getSizes"
			},
			"flickr.photos.getUntagged": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.photos.getUntagged"
			},
			"flickr.photos.getWithGeoData": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.photos.getWithGeoData"
			},
			"flickr.photos.getWithoutGeoData": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.photos.getWithoutGeoData"
			},
			"flickr.photos.licenses.getInfo": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.photos.licenses.getInfo"
			},
			"flickr.photos.licenses.setLicense": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.licenses.setLicense"
			},
			"flickr.photos.notes.add": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.notes.add"
			},
			"flickr.photos.notes.delete": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.notes.delete"
			},
			"flickr.photos.notes.edit": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.notes.edit"
			},
			"flickr.photos.people.add": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.people.add"
			},
			"flickr.photos.people.delete": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.people.delete"
			},
			"flickr.photos.people.deleteCoords": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.people.deleteCoords"
			},
			"flickr.photos.people.editCoords": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.people.editCoords"
			},
			"flickr.photos.people.getList": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.photos.people.getList"
			},
			"flickr.photos.recentlyUpdated": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.photos.recentlyUpdated"
			},
			"flickr.photos.removeTag": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.removeTag"
			},
			"flickr.photos.search": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.photos.search"
			},
			"flickr.photos.setContentType": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.setContentType"
			},
			"flickr.photos.setDates": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.setDates"
			},
			"flickr.photos.setMeta": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.setMeta"
			},
			"flickr.photos.setPerms": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.setPerms"
			},
			"flickr.photos.setSafetyLevel": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.setSafetyLevel"
			},
			"flickr.photos.setTags": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.setTags"
			},
			"flickr.photos.suggestions.approveSuggestion": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.suggestions.approveSuggestion"
			},
			"flickr.photos.suggestions.getList": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.photos.suggestions.getList"
			},
			"flickr.photos.suggestions.rejectSuggestion": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.suggestions.rejectSuggestion"
			},
			"flickr.photos.suggestions.removeSuggestion": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.suggestions.removeSuggestion"
			},
			"flickr.photos.suggestions.suggestLocation": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.suggestions.suggestLocation"
			},
			"flickr.photos.transform.rotate": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photos.transform.rotate"
			},
			"flickr.photos.upload.checkTickets": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.photos.upload.checkTickets"
			},
			"flickr.photosets.addPhoto": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photosets.addPhoto"
			},
			"flickr.photosets.comments.addComment": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photosets.comments.addComment"
			},
			"flickr.photosets.comments.deleteComment": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photosets.comments.deleteComment"
			},
			"flickr.photosets.comments.editComment": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photosets.comments.editComment"
			},
			"flickr.photosets.comments.getList": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.photosets.comments.getList"
			},
			"flickr.photosets.create": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photosets.create"
			},
			"flickr.photosets.delete": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photosets.delete"
			},
			"flickr.photosets.editMeta": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photosets.editMeta"
			},
			"flickr.photosets.editPhotos": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photosets.editPhotos"
			},
			"flickr.photosets.getContext": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.photosets.getContext"
			},
			"flickr.photosets.getInfo": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.photosets.getInfo"
			},
			"flickr.photosets.getList": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.photosets.getList"
			},
			"flickr.photosets.getPhotos": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.photosets.getPhotos"
			},
			"flickr.photosets.orderSets": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photosets.orderSets"
			},
			"flickr.photosets.removePhoto": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photosets.removePhoto"
			},
			"flickr.photosets.removePhotos": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photosets.removePhotos"
			},
			"flickr.photosets.reorderPhotos": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photosets.reorderPhotos"
			},
			"flickr.photosets.setPrimaryPhoto": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 2
				},
				"name": "flickr.photosets.setPrimaryPhoto"
			},
			"flickr.places.find": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.places.find"
			},
			"flickr.places.findByLatLon": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.places.findByLatLon"
			},
			"flickr.places.getChildrenWithPhotosPublic": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.places.getChildrenWithPhotosPublic"
			},
			"flickr.places.getInfo": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.places.getInfo"
			},
			"flickr.places.getInfoByUrl": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.places.getInfoByUrl"
			},
			"flickr.places.getPlaceTypes": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.places.getPlaceTypes"
			},
			"flickr.places.getShapeHistory": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.places.getShapeHistory"
			},
			"flickr.places.getTopPlacesList": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.places.getTopPlacesList"
			},
			"flickr.places.placesForBoundingBox": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.places.placesForBoundingBox"
			},
			"flickr.places.placesForContacts": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.places.placesForContacts"
			},
			"flickr.places.placesForTags": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.places.placesForTags"
			},
			"flickr.places.placesForUser": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.places.placesForUser"
			},
			"flickr.places.resolvePlaceId": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.places.resolvePlaceId"
			},
			"flickr.places.resolvePlaceURL": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.places.resolvePlaceURL"
			},
			"flickr.places.tagsForPlace": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.places.tagsForPlace"
			},
			"flickr.prefs.getContentType": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.prefs.getContentType"
			},
			"flickr.prefs.getGeoPerms": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.prefs.getGeoPerms"
			},
			"flickr.prefs.getHidden": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.prefs.getHidden"
			},
			"flickr.prefs.getPrivacy": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.prefs.getPrivacy"
			},
			"flickr.prefs.getSafetyLevel": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.prefs.getSafetyLevel"
			},
			"flickr.push.getSubscriptions": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.push.getSubscriptions"
			},
			"flickr.push.getTopics": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.push.getTopics"
			},
			"flickr.push.subscribe": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.push.subscribe"
			},
			"flickr.push.unsubscribe": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.push.unsubscribe"
			},
			"flickr.reflection.getMethodInfo": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.reflection.getMethodInfo"
			},
			"flickr.reflection.getMethods": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.reflection.getMethods"
			},
			"flickr.stats.getCollectionDomains": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.stats.getCollectionDomains"
			},
			"flickr.stats.getCollectionReferrers": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.stats.getCollectionReferrers"
			},
			"flickr.stats.getCollectionStats": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.stats.getCollectionStats"
			},
			"flickr.stats.getCSVFiles": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.stats.getCSVFiles"
			},
			"flickr.stats.getPhotoDomains": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.stats.getPhotoDomains"
			},
			"flickr.stats.getPhotoReferrers": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.stats.getPhotoReferrers"
			},
			"flickr.stats.getPhotosetDomains": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.stats.getPhotosetDomains"
			},
			"flickr.stats.getPhotosetReferrers": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.stats.getPhotosetReferrers"
			},
			"flickr.stats.getPhotosetStats": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.stats.getPhotosetStats"
			},
			"flickr.stats.getPhotoStats": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.stats.getPhotoStats"
			},
			"flickr.stats.getPhotostreamDomains": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.stats.getPhotostreamDomains"
			},
			"flickr.stats.getPhotostreamReferrers": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.stats.getPhotostreamReferrers"
			},
			"flickr.stats.getPhotostreamStats": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.stats.getPhotostreamStats"
			},
			"flickr.stats.getPopularPhotos": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.stats.getPopularPhotos"
			},
			"flickr.stats.getTotalViews": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.stats.getTotalViews"
			},
			"flickr.tags.getClusterPhotos": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.tags.getClusterPhotos"
			},
			"flickr.tags.getClusters": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.tags.getClusters"
			},
			"flickr.tags.getHotList": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.tags.getHotList"
			},
			"flickr.tags.getListPhoto": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.tags.getListPhoto"
			},
			"flickr.tags.getListUser": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.tags.getListUser"
			},
			"flickr.tags.getListUserPopular": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.tags.getListUserPopular"
			},
			"flickr.tags.getListUserRaw": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.tags.getListUserRaw"
			},
			"flickr.tags.getMostFrequentlyUsed": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.tags.getMostFrequentlyUsed"
			},
			"flickr.tags.getRelated": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.tags.getRelated"
			},
			"flickr.test.echo": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.test.echo"
			},
			"flickr.test.login": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.test.login"
			},
			"flickr.test.null": {
				"security": {
					"needslogin": 1,
					"needssigning": 1,
					"requiredperms": 1
				},
				"name": "flickr.test.null"
			},
			"flickr.urls.getGroup": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.urls.getGroup"
			},
			"flickr.urls.getUserPhotos": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.urls.getUserPhotos"
			},
			"flickr.urls.getUserProfile": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.urls.getUserProfile"
			},
			"flickr.urls.lookupGallery": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.urls.lookupGallery"
			},
			"flickr.urls.lookupGroup": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.urls.lookupGroup"
			},
			"flickr.urls.lookupUser": {
				"security": {
					"needslogin": 0,
					"needssigning": 0,
					"requiredperms": 0
				},
				"name": "flickr.urls.lookupUser"
			}
		};
	
		(function () {
			(0, _keys2.default)(Flickr.methods).forEach(function (method) {
				var level = method.split(".").slice(1);
				var e = Flickr.prototype,
				    key;
				while (level.length > 1) {
					key = level.splice(0, 1)[0];
					if (!e[key]) {
						e[key] = {};
					}
					e = e[key];
				}
				e[level] = Utils.generateAPIFunction(Flickr.methods[method]);
			});
		})();
	
		Flickr.prototype.bindOptions = function (flickrOptions) {
			this.flickrOptions = flickrOptions;
			(function bindOptions(obj, props) {
				(0, _keys2.default)(props).forEach(function (key) {
					if (key === "flickrOptions") return;
					if ((0, _typeof3.default)(obj[key]) === "object") {
						bindOptions(obj[key], props[key]);
						obj[key].flickrOptions = flickrOptions;
					}
				});
			})(this, Flickr.prototype);
		};
	
		window.Flickr = Flickr;
	})();
	
	exports.default = {
		Flickr: Flickr
	};

/***/ },
/* 57 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var values = {
		FLICKR_API_KEY: 'dfd8c2b698749aa6f895bc582941ccc3',
		FLICKR_SECRET: 'df2a1bda6566a1c6',
		FLICKR_USER_ID: '70247946@N00'
	};
	
	exports.default = values;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _About = __webpack_require__(113);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Home = __webpack_require__(114);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Photoset = __webpack_require__(115);
	
	var _Photoset2 = _interopRequireDefault(_Photoset);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routes = [{ name: 'about', path: '/about', component: _About2.default }, { name: 'home', path: '/home', component: _Home2.default }, { name: 'photoset', path: '/photoset/:id', component: _Photoset2.default }, { path: '*', redirect: '/home' }];
	
	exports.default = routes;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(44);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(19);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var debug = ("production") !== 'production';
	
	var state = {
		introOpen: true,
		modalOpen: false
	};
	
	var mutations = {
		toggleIntro: function toggleIntro(state, isOpen) {
			state.introOpen = isOpen;
		},
		toggleModalOpen: function toggleModalOpen(state, isOpen) {
			state.modalOpen = isOpen;
		}
	};
	
	var getters = {
		introOpen: function introOpen(state) {
			return state.introOpen;
		},
		modalOpen: function modalOpen(state) {
			return state.modalOpen;
		}
	};
	
	exports.default = new _vuex2.default.Store({
		state: state,
		getters: getters,
		mutations: mutations,
		strict: debug
	});

/***/ },
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 103 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 104 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 105 */,
/* 106 */,
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(102)
	__webpack_require__(103)
	
	/* script */
	__vue_exports__ = __webpack_require__(45)
	
	/* template */
	var __vue_template__ = __webpack_require__(116)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(46)
	
	/* template */
	var __vue_template__ = __webpack_require__(123)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(104)
	
	/* script */
	__vue_exports__ = __webpack_require__(48)
	
	/* template */
	var __vue_template__ = __webpack_require__(119)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(49)
	
	/* template */
	var __vue_template__ = __webpack_require__(120)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(50)
	
	/* template */
	var __vue_template__ = __webpack_require__(121)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(51)
	
	/* template */
	var __vue_template__ = __webpack_require__(117)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(52)
	
	/* template */
	var __vue_template__ = __webpack_require__(118)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(53)
	
	/* template */
	var __vue_template__ = __webpack_require__(125)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(54)
	
	/* template */
	var __vue_template__ = __webpack_require__(124)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 116 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: [_vm.introOpen ? 'intro-open' : '', _vm.modalOpen ? 'modal-open' : '', _vm.$route.name],
	    attrs: {
	      "id": "app"
	    }
	  }, [(_vm.$route.name == 'home') ? _c('site-intro') : _vm._e(), _vm._v(" "), _c('navbar'), _vm._v(" "), _c('main', {
	    attrs: {
	      "id": "main"
	    }
	  }, [_c('router-view')], 1), _vm._v(" "), _c('site-footer')], 1)
	},staticRenderFns: []}

/***/ },
/* 117 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "intro",
	    staticClass: "intro slide-loadable",
	    class: {
	      'loaded': _vm.imageLoaded
	    },
	    style: ({
	      filter: 'grayscale(' + _vm.introFade + '%)',
	      backgroundImage: 'url(' + _vm.photoSource + ')'
	    }),
	    attrs: {
	      "id": "site-intro",
	      "role": "presentation"
	    }
	  })
	},staticRenderFns: []}

/***/ },
/* 118 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('section', {
	    staticClass: "panel panel-about"
	  }, [_c('header', {
	    staticClass: "panel-heading"
	  }, [_c('h1', {
	    staticClass: "panel-title"
	  }, [_vm._v("About Colin")])]), _vm._v(" "), _c('div', {
	    staticClass: "panel-body"
	  }, [_c('p', [_vm._v("Boulder based, Cincinnati sourced. Left-handed excellence since 1983.")]), _vm._v(" "), _c('ul', {
	    staticClass: "icon-group"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "https://www.facebook.com/ColinJosephStevenson",
	      "target": "_blank"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Facebook")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-facebook"
	  })])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://www.linkedin.com/in/colinjstevenson",
	      "target": "_blank"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("LinkedIn")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-linkedin"
	  })])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://www.instagram.com/cojsteve/",
	      "target": "_blank"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Instagram")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-instagram"
	  })])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://www.flickr.com/photos/colinstevenson/",
	      "target": "_blank"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Flickr")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-flickr"
	  })])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://github.com/colinStevenson",
	      "target": "_blank"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Github")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-github"
	  })])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "https://twitter.com/cojsteve",
	      "target": "_blank"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Twitter")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-twitter"
	  })])])])])])])
	}]}

/***/ },
/* 119 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "photo-full-screen",
	    class: {
	      'in': _vm.isIn
	    }
	  }, [_c('button', {
	    staticClass: "close btn-link",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.handleClose($event)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-cross"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Close")])]), _vm._v(" "), _c('div', [(_vm.previous !== null) ? _c('button', {
	    staticClass: "btn btn-link previous",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.goToIndex(_vm.previous)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Previous Photo")]), _vm._v(" "), _c('span', [_vm._v("◀")])]) : _vm._e(), _vm._v(" "), (_vm.next) ? _c('button', {
	    staticClass: "btn btn-link next",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.goToIndex(_vm.next)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Next Photo")]), _vm._v(" "), _c('span', [_vm._v("▶")])]) : _vm._e()]), _vm._v(" "), _c('figure', [(_vm.hasSizesData) ? _c('img', {
	    staticClass: "img-responsive img-loadable",
	    class: {
	      'loaded': _vm.imageLoaded
	    },
	    attrs: {
	      "src": _vm.photoSource,
	      "alt": _vm.meta.title._content
	    },
	    on: {
	      "load": _vm.handleImageLoad
	    }
	  }) : _vm._e(), _vm._v(" "), _c('figcaption', {
	    staticClass: "meta"
	  }, [_c('h1', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.meta.title._content))]), _vm._v(" "), (_vm.meta.description._content && _vm.meta.description._content !== '') ? _c('p', [_vm._v(_vm._s(_vm.meta.description._content))]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ },
/* 120 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "slide slide-link"
	  }, [_c('div', {
	    staticClass: "slide-media slide-loadable",
	    class: {
	      'loaded': _vm.imageLoaded
	    },
	    style: ({
	      backgroundImage: 'url(' + _vm.photoSource + ')'
	    })
	  }), _vm._v(" "), _c('div', {
	    staticClass: "slide-body"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'photoset',
	        params: {
	          id: _vm.details.id
	        }
	      }
	    }
	  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.details.title._content) + "\n\t\t")])], 1)])
	},staticRenderFns: []}

/***/ },
/* 121 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', [_c('div', {
	    staticClass: "container"
	  }, [_vm._v("\n\t\t© " + _vm._s(_vm.year) + ". All rights reserved.\n\t")])])
	},staticRenderFns: []}

/***/ },
/* 122 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.includeMeta) ? _c('div', {
	    staticClass: "meta"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.meta.title._content))])]) : _vm._e(), _vm._v(" "), (_vm.hasSizesData) ? _c('img', {
	    staticClass: "img-responsive img-loadable",
	    class: {
	      'loaded': _vm.imageLoaded
	    },
	    attrs: {
	      "src": _vm.getSource(),
	      "alt": _vm.meta.title._content
	    },
	    on: {
	      "load": _vm.handleImageLoad
	    }
	  }) : _vm._e()])
	},staticRenderFns: []}

/***/ },
/* 123 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "navbar navbar-default"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('h1', {
	    staticClass: "navbar-brand",
	    on: {
	      "click": _vm.scrollToIntro
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'home',
	        params: {
	          intro: true
	        }
	      }
	    }
	  }, [_vm._v("Colin Stevenson")])], 1), _vm._v(" "), _c('ul', {
	    staticClass: "navbar-right nav navbar-nav"
	  }, [_c('li', {
	    staticClass: "photography-tab",
	    class: {
	      active: _vm.isPhotographyRoute
	    },
	    attrs: {
	      "id": "photography-tab"
	    },
	    on: {
	      "click": _vm.scrollToMain
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'home',
	        params: {
	          intro: false
	        }
	      }
	    }
	  }, [_c('span', {
	    staticClass: "hidden-xs"
	  }, [_vm._v("Photography")]), _vm._v(" "), _c('span', {
	    staticClass: "visible-xs"
	  }, [_vm._v("Photos")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'about'
	      }
	    }
	  }, [_vm._v("About")])], 1)])])])
	},staticRenderFns: []}

/***/ },
/* 124 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.hasPhotosetData) ? _c('div', [_c('header', {
	    staticClass: "page-header"
	  }, [_c('div', {
	    staticClass: "page-header-media slide-loadable",
	    class: {
	      'loaded': _vm.imageLoaded
	    },
	    style: ({
	      backgroundImage: 'url(' + _vm.photoSource + ')'
	    }),
	    attrs: {
	      "role": "presentation"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "page-header-body"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('h1', {
	    staticClass: "page-title"
	  }, [_vm._v(_vm._s(_vm.photosetData.title._content))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.photosetData.description._content))])])])]), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.photos), function(photo, index) {
	    return _c('div', {
	      staticClass: "col-md-3 col-xs-4",
	      attrs: {
	        "data-index": index > 0
	      }
	    }, [_c('div', {
	      staticClass: "slide slide-square slide-link",
	      on: {
	        "click": function($event) {
	          _vm.handlePhotoClick(index)
	        }
	      }
	    }, [_c('photo', {
	      attrs: {
	        "id": photo.id,
	        "size": 1
	      }
	    }), _vm._v(" "), (_vm.activePhoto == photo.id) ? _c('photo-full-screen', {
	      attrs: {
	        "id": photo.id,
	        "next": index + 1 < _vm.photos.length ? index + 1 : null,
	        "previous": index > 0 ? index - 1 : null,
	        "include-meta": true
	      }
	    }) : _vm._e()], 1)])
	  }))])]) : _vm._e()
	},staticRenderFns: []}

/***/ },
/* 125 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "row"
	  }, _vm._l((_vm.photosets), function(set) {
	    return _c('div', {
	      staticClass: "col-md-4",
	      on: {
	        "click": function($event) {
	          _vm.goToPhotoset(set.id)
	        }
	      }
	    }, [_c('photoset-intro', {
	      attrs: {
	        "details": set
	      }
	    })], 1)
	  }))])
	},staticRenderFns: []}

/***/ },
/* 126 */,
/* 127 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.234c0cb137bc14d212a5.js